import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

const Blog = () => {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="blog-page">
      <section className="px-6 md:px-12 lg:px-20 pt-24 pb-16 md:pt-32">
        <p className="overline mb-6">The Journal</p>
        <h1 className="text-5xl sm:text-7xl tracking-tight font-light max-w-4xl leading-[1.05]">
          Quiet writing on <em className="font-display italic" style={{ color: "var(--ayu-secondary)" }}>doshas, dinacharya, and the herbs we love.</em>
        </h1>
      </section>

      <section className="px-6 md:px-12 lg:px-20 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {posts.map((p) => (
            <Link key={p.id} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group block">
              <div className="aspect-[16/10] overflow-hidden mb-6">
                <img src={p.image} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
              </div>
              <p className="overline mb-3">{p.author}</p>
              <h2 className="font-display text-3xl leading-snug mb-3 group-hover:text-[var(--ayu-secondary)] transition-colors">{p.title}</h2>
              <p className="text-sm leading-relaxed mb-4" style={{ color: "var(--ayu-body)" }}>{p.excerpt}</p>
              <span className="text-sm inline-flex items-center gap-2" style={{ color: "var(--ayu-secondary)" }}>
                Read essay <ArrowRight size={14} />
              </span>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Blog;
